"use strict";
/**
 * @module Util.Object
 *
 * @brief Utility functions for objects and object types
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Cheap type guard for a specific type
 *
 * Check is a variable is an object and assume that it is of a given type
 *
 * @param  o    the object to check
 * @param  <T>  the type that is assumed if `o` is an object
 * @return      `true` if `o` is an object
 */
function isObjectAs(o) {
    return (o instanceof Object);
}
exports.isObjectAs = isObjectAs;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/util/object.js
// module id = 2072
// module chunks = 1